<template>
  <div class="GeneralSales">
    <div class="headerGeneralSales">
      <b-button class="BtnRegister" @click="handleModals('venda')">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 3px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Nova Venda Simples</span>
      </b-button>
      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            class="searchFilter"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterCombobox"
          ></b-form-select>
          <div>
            <b-input
              class="inputSearch"
              placeholder="Pesquisar por..."
              v-model="textPesquisa"
              @keyup.enter="filterSale(page)"
            ></b-input>
          </div>
        </div>
        <div class="lineSearch">
          <div class="summaryMonth">
            Resumo: &nbsp;
            <strong>{{
              selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
            }}</strong>
          </div>
          <div class="pagMonth"></div>
          <div
            class="searchInput"
            style="
              padding: 0px !important;
              display: flex;
              justify-content: space-between;
            "
            v-if="selectTextDate === 'Personalizado'"
          >
            <button class="btnPeriod" size="sm">Período</button>
            <div class="dateInput">
              <input
                type="date"
                id="date"
                v-model="startDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                  cursor: pointer;
                  border-left: none;
                  width: 120px;
                  border-radius: 0px 5px 5px 0px;
                "
              />
              <input
                type="date"
                id="date"
                v-model="endDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                  cursor: pointer;
                  width: 120px;
                  border-right: none;
                  border-radius: 5px 0 0 5px;
                "
              />
            </div>
            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>

          <div style="width: 25px">
            <DropdownFilters @handleFilterDays="handleFilterDays" />
          </div>
        </div>
      </div>
    </div>
    <div class="headerCounter">
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Rascunho')"
        :style="
          status === 'Rascunho' && 'background-color: transparent; color: black'
        "
      >
        <span
          style="
            width: 10px;
            height: 10px;
            background: gray;
            border-radius: 50%;
          "
        ></span>
        <span>Rascunhos</span>
        <span v-if="!status || status === 'Rascunho'">
          - {{ this.countRascunho }}</span
        >
        <span v-if="!status || status === 'Rascunho'">
          (
          {{
            canViewSummaryValues
              ? this.totalrascunho.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Finalizado(a)')"
        :style="
          status === 'Finalizado(a)' &&
          'background-color: transparent; color: black'
        "
      >
        <span
          style="
            width: 10px;
            height: 10px;
            background: green;
            border-radius: 50%;
          "
        ></span>
        <span>Finalizadas</span>
        <span v-if="!status || status === 'Finalizado(a)'">
          - {{ this.countFinalizado }}</span
        >
        <span v-if="!status || status === 'Finalizado(a)'">
          (
          {{
            canViewSummaryValues
              ? this.totalfinalizado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Cancelado')"
        :style="
          status === 'Cancelado' &&
          'background-color: transparent; color: black'
        "
      >
        <span
          style="width: 10px; height: 10px; background: red; border-radius: 50%"
        ></span>
        <span>Canceladas</span>
        <span v-if="!status || status === 'Cancelado'">
          - {{ this.countCancelado }}
        </span>
        <span v-if="!status || status === 'Cancelado'"
          >(
          {{
            canViewSummaryValues
              ? this.totalcancelado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )
        </span>
      </b-button>
    </div>
    <div class="generalContainer">
      <div class="rowProvisionService" v-if="spinGeneral">
        <div class="loadingLazy">
          <div class="loader">
            <span>WINFIT</span>
            <span>WINFIT</span>
          </div>
          <span style="">Buscando Informações...</span>
        </div>
      </div>
      <div class="rowProvisionService" v-else>
        <div class="ContentTable" v-if="this.dataLength > 0">
          <div class="headerTable">
            <div class="celTable" style="width: 2%; text-align: center"></div>
            <div class="celTable" style="width: 2%; text-align: center">Nº</div>
            <div class="celTable" style="width: 10%">Data</div>
            <div class="celTable" style="width: 35%">Cliente</div>
            <div class="celTable" style="width: 15%">Funcionário</div>
            <div class="celTable" style="width: 10%">Valor Pago</div>
            <div class="celTable" style="width: 10%">Valor Total</div>
            <div class="celTable" style="width: 9%">Emissão</div>
            <div class="celTableActions">Ações</div>
          </div>

          <div
            v-for="dataSearchSale in dataSale"
            :key="dataSearchSale.id"
            :class="`rowSupplier`"
            @click.stop="editSales(dataSearchSale)"
          >
            <div
              class="celTable"
              style="
                width: 2%;
                justify-content: center;
                align-items: center;
                text-align: center;
              "
            >
              <span
                v-if="dataSearchSale.status === 'Finalizado(a)'"
                class="ballStatus"
                style="background: green"
              >
              </span>
              <span
                v-if="dataSearchSale.status === 'Cancelado'"
                class="ballStatus"
                style="background: red"
              >
              </span>
              <span
                v-if="dataSearchSale.status === 'Rascunho'"
                class="ballStatus"
                style="background: gray"
              >
              </span>
            </div>
            <div
              class="celTable"
              style="
                width: 2%;
                justify-content: center;
                align-items: center;
                text-align: center;
              "
            >
              <span
                style="
                  width: 100%;
                  font-weight: bold;
                  color: #006256;
                  font-size: 13px;
                "
              >
                {{ dataSearchSale.numero || 0 }}
              </span>
            </div>
            <div class="celTable" style="width: 10%">
              {{ dataSearchSale.data.split("-").reverse().join("/") }}
            </div>
            <div
              class="celTable"
              style="
                width: 35%;
                color: #3e66ae;
                font-weight: bold;
                text-transform: uppercase;
                padding-left: 3px;
              "
            >
              {{ dataSearchSale.nomeCliente || "CONSUMIDOR FINAL" }}
            </div>
            <div class="celTable" style="width: 15%">
              {{ dataSearchSale.nomeFuncionario || "Não informado" }}
            </div>
            <div
              class="celTable"
              style="
                width: 10%;
                flex-direction: row !important;
                justify-content: center;
                align-items: center;
                gap: 5px;
              "
              v-if="dataSearchSale.totalPago === dataSearchSale.valorTotal"
            >
              <b-icon-check-circle-fill scale="1.1" style="color: green" />
              Pago
            </div>
            <div class="celTable" style="width: 10%" v-else>
              {{
                parseFloat(dataSearchSale.totalPago || 0).toLocaleString(
                  "pt-br",
                  {
                    style: "currency",
                    currency: "BRL",
                  }
                )
              }}
            </div>
            <div class="celTable" style="width: 10%">
              {{
                dataSearchSale.valorTotal.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </div>
            <div
              class="celTable"
              :style="`
                  color: #006256;
                  width: 9%;
                   background-color: ${
                     ['Emitida', 'Devolvida'].includes(
                       dataSearchSale.statusNota
                     )
                       ? '#ddebff'
                       : '#ffcfc9'
                   };
                  border-radius: 8px;
                `"
              v-if="dataSearchSale.idNota && dataSearchSale.modelosNota === '1'"
            >
              NF-e
            </div>

            <div
              class="celTable"
              :style="`
                  color: #006256;
                  width: 9%;
                  background-color: ${
                    ['Emitida', 'Devolvida'].includes(dataSearchSale.statusNota)
                      ? '#d4edbc'
                      : '#ffcfc9'
                  };
                  border-radius: 8px;
                `"
              v-else-if="
                dataSearchSale.idNota && dataSearchSale.modelosNota === '2'
              "
            >
              NFC-e
            </div>
            <div class="celTable" style="width: 9%" v-else>--</div>
            <div class="celTableActions">
              <div class="btnActions">
                <b-dropdown
                  id="dropdown-1"
                  class="btnActions1"
                  variant="none"
                  size="sm"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                  </template>

                  <b-dropdown-item @click.stop="editSales(dataSearchSale)">
                    Editar
                  </b-dropdown-item>

                  <div
                    v-if="dataSearchSale.tipo === 'Pedido'"
                    class="dropdown-submenu"
                    @mouseenter="showSubmenu = true"
                    @mouseleave="showSubmenu = false"
                  >
                    <b-dropdown-item>
                      <b-icon-arrow-left scale="1" /> Documentos
                      Fiscais</b-dropdown-item
                    >

                    <div v-if="showSubmenu" class="submenu">
                      <b-dropdown-item
                        v-if="
                          !dataSearchSale.statusNota ||
                          !['Emitida', 'Devolvida'].includes(
                            dataSearchSale.statusNota
                          )
                        "
                        @click.stop="sendCoupon(dataSearchSale.id)"
                        >Emitir NFC-e</b-dropdown-item
                      >

                      <b-dropdown-item
                        v-if="
                          !dataSearchSale.statusNota ||
                          !['Emitida', 'Devolvida'].includes(
                            dataSearchSale.statusNota
                          )
                        "
                        @click.stop="transformToNfe(dataSearchSale.id)"
                        >Emitir NF-e</b-dropdown-item
                      >

                      <b-dropdown-item
                        @click.stop="findAndViewNote(dataSearchSale.idNota)"
                        v-if="
                          dataSearchSale.idNota !== null &&
                          dataSearchSale.statusNota &&
                          dataSearchSale.statusNota !== 'Não Enviada'
                        "
                      >
                        Visualizar
                        {{
                          dataSearchSale.modelosNota === "1" ? "NF-e" : "NFC-e"
                        }}
                      </b-dropdown-item>

                      <b-dropdown-item
                        @click.stop="
                          handleOpenModalAndFindFiscalDocument(
                            'modal-cancel',
                            dataSearchSale
                          )
                        "
                        v-if="
                          dataSearchSale.idNota !== null &&
                          dataSearchSale.statusNota &&
                          dataSearchSale.statusNota === 'Emitida'
                        "
                      >
                        Cancelar
                        {{
                          dataSearchSale.modelosNota === "1" ? "NF-e" : "NFC-e"
                        }}
                      </b-dropdown-item>
                    </div>
                  </div>

                  <div
                    v-if="dataSearchSale.tipo === 'Receita Pedido'"
                    class="dropdown-submenu"
                    @mouseenter="showSubmenuPrescription = true"
                    @mouseleave="showSubmenuPrescription = false"
                  >
                    <b-dropdown-item @click.stop.prevent>
                      <b-icon-arrow-left scale="1" /> Receita</b-dropdown-item
                    >

                    <div v-if="showSubmenuPrescription" class="submenu">
                      <b-dropdown-item
                        @click.stop="printReportReceipt(dataSearchSale.id)"
                        >Imprimir</b-dropdown-item
                      >

                      <b-dropdown-item
                        v-if="canUseDigitalSignature(dataSearchSale.tipo)"
                        >Assinar Digitalmente</b-dropdown-item
                      >
                    </div>
                  </div>

                  <div
                    v-if="dataSearchSale.tipo === 'Receita Pedido'"
                    class="dropdown-submenu"
                    @mouseenter="showSubmenuGeneralSale = true"
                    @mouseleave="showSubmenuGeneralSale = false"
                  >
                    <b-dropdown-item @click.stop.prevent>
                      <b-icon-arrow-left scale="1" /> Venda</b-dropdown-item
                    >

                    <div v-if="showSubmenuGeneralSale" class="submenu">
                      <b-dropdown-item
                        @click.stop="
                          printCouponOrA4(
                            dataSearchSale.tipo,
                            dataSearchSale.id
                          )
                        "
                        >Imprimir</b-dropdown-item
                      >

                      <b-dropdown-item
                        v-if="
                          !dataSearchSale.statusNota ||
                          !['Emitida', 'Devolvida'].includes(
                            dataSearchSale.statusNota
                          )
                        "
                        @click.stop="sendCoupon(dataSearchSale.id)"
                        >Emitir NFC-e</b-dropdown-item
                      >

                      <b-dropdown-item
                        v-if="
                          !dataSearchSale.statusNota ||
                          !['Emitida', 'Devolvida'].includes(
                            dataSearchSale.statusNota
                          )
                        "
                        @click.stop="transformToNfe(dataSearchSale.id)"
                        >Emitir NF-e</b-dropdown-item
                      >

                      <b-dropdown-item
                        @click.stop="findAndViewNote(dataSearchSale.idNota)"
                        v-if="
                          dataSearchSale.idNota !== null &&
                          dataSearchSale.statusNota &&
                          dataSearchSale.statusNota !== 'Não Enviada'
                        "
                      >
                        Visualizar
                        {{
                          dataSearchSale.modelosNota === "1" ? "NF-e" : "NFC-e"
                        }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click.stop="
                          handleOpenModalAndFindFiscalDocument(
                            'modal-cancel',
                            dataSearchSale
                          )
                        "
                        v-if="
                          dataSearchSale.idNota !== null &&
                          dataSearchSale.statusNota &&
                          dataSearchSale.statusNota === 'Emitida'
                        "
                      >
                        Cancelar
                        {{
                          dataSearchSale.modelosNota === "1" ? "NF-e" : "NFC-e"
                        }}
                      </b-dropdown-item>
                    </div>
                  </div>

                  <b-dropdown-item
                    v-if="dataSearchSale.tipo !== 'Receita Pedido'"
                    @click.stop="
                      dataSearchSale.tipo === 'Receita'
                        ? printReportReceipt(dataSearchSale.id)
                        : printCouponOrA4(
                            dataSearchSale.tipo,
                            dataSearchSale.id
                          )
                    "
                  >
                    Imprimir
                  </b-dropdown-item>

                  <b-dropdown-item
                    @click.stop="printReportCoupon(dataSearchSale.id)"
                    >Imprimir Recibo</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      dataSearchSale.tipo === 'Receita' &&
                      canUseDigitalSignature(dataSearchSale.tipo)
                    "
                    >Assinar Digitalmente</b-dropdown-item
                  >

                  <b-dropdown-item
                    @click.stop="findBillReportTicket(dataSearchSale.id)"
                    v-if="
                      dataSearchSale.tipo !== typeSale.orcamento &&
                      dataSearchSale.situacao === 'Finalizado(a)'
                    "
                  >
                    Gerar Carnê
                  </b-dropdown-item>

                  <!-- <b-dropdown-item
                    v-if="
                      dataSearchSale.tipo !== 'Receita' &&
                      dataSearchSale.tipo !== 'Receita Pedido'
                    "
                    @click.stop="handleDuplicateSale(dataSearchSale)"
                  >
                    Clonar
                  </b-dropdown-item> -->

                  <b-dropdown-item
                    v-b-modal.modalDetailsSimpleSale
                    @click.stop="getIdSaleDetails(dataSearchSale.id)"
                  >
                    Ver detalhes
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      dataSearchSale.tipo === 'Receita' ||
                      dataSearchSale.tipo === 'Receita Pedido'
                    "
                  >
                    Inativar
                  </b-dropdown-item>

                  <b-dropdown-item @click.stop="editSales(dataSearchSale)">
                    Cancelar
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="dataSearchSale.tipo === 'Pedido'"
                    @click.stop="openModalDropSale(dataSearchSale.id)"
                  >
                    Excluir
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40vh;
            max-height: 100vh;
            overflow: auto;
            padding: 10px 20px;
            width: 100%;
            max-width: 100%;
          "
        >
          <span style="font-size: 1rem; font-weight: bold; color: gray"
            >Não há dados para exibir ...</span
          >
        </div>
      </div>
    </div>
    <b-modal
      id="modal-center3"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div>
        <h6 class="titleModal">Deseja excluir essa movimentação ?</h6>
        <div class="btnModal">
          <button class="btnContent" @click="deleteSale">Deletar</button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center3')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-cancel" hide-footer hide-header centered title="Excluir">
      <div>
        <h4 class="titleModal" style="text-align: center">
          Deseja cancelar essa {{ nameFiscalDocument }} ?
        </h4>
        <div class="btnModalCancel">
          <div class="contentMotivo">
            <label>Descreva o motivo do cancelamento:</label> <span>*</span>
            <b-form-textarea
              placeholder="Min: 15 caracteres"
              style="color: black; width: 100% !important"
              v-model="motivo"
            ></b-form-textarea>
          </div>
          <div class="contentBtns">
            <button class="btnContent" @click="cancelNota()">
              Cancelar {{ nameFiscalDocument }}
            </button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modal-cancel')"
            >
              Não, Obrigado!
            </button>
          </div>
        </div>
        <span class="alertCancel">
          O prazo máximo para cancelamento de uma {{ nameFiscalDocument }} é de
          até {{ textTimeToCancel }} após a concessão da autorização de uso.
        </span>
      </div>
    </b-modal>
    <!-- <b-modal
      id="modal-center4"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Detalhes"
    >
      <div class="closeModalDetails" @click="$bvModal.hide('modal-center4')">
        X
      </div>
      <div class="contentModal">
        <span><b-icon-file-text></b-icon-file-text> Informações Básicas</span>
        <div class="rowModal">
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="this.detailsSales.data"
            />
            <label class="user-label"> Data</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.numero"
            />
            <label class="user-label"> Nº Operação </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.status"
            />
            <label class="user-label"> Status </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeCliente"
            />
            <label class="user-label"> Cliente. </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.cpfCnpj"
            />
            <label class="user-label"> CPF/CNPJ. </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeFuncionario"
            />
            <label class="user-label"> Funcionario. </label>
          </div>
        </div>
      </div>
      <div class="contentModal">
        <span><b-icon-box-seam></b-icon-box-seam>Produtos</span>
        <div class="rowModal">
          <table style="border-spacing: 1px 0; width: 100%">
            <thead
              style="
                color: whitesmoke;
                background: #3a4750;
                padding: 10px;
                height: 35px;
                text-align: center;
                border-spacing: 0;
              "
            >
              <tr>
                <th style="width: 10%">Nome</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 10%">Observação</th>
                <th style="width: 10%">Qtd</th>
                <th style="width: 10%">Valor Unitário</th>
                <th style="width: 10%">Desconto</th>
                <th style="width: 10%">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="detailsSale in this.detailsSales.products"
                :key="detailsSale.id"
                style="
                  text-align: center;
                  height: 60px;
                  border-bottom: 1px solid rgb(218, 218, 218);
                "
              >
                <td>
                  {{ detailsSale.nome }}
                </td>
                <td>
                  {{ detailsSale.tipoProduto }}
                </td>
                <td>{{ detailsSale.dadosAdicionais || "--" }}</td>
                <td style="width: 10%">
                  {{ detailsSale.quantidade }}
                </td>
                <td>
                  {{ detailsSale.valorUnitario }}
                </td>
                <td>
                  {{ detailsSale.desconto || "--" }}
                </td>
                <td>
                  {{ detailsSale.valorTotal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="contentModal" v-if="this.detailsSales.status === 'Venda'">
        <span
          ><b-icon-credit-card-fill></b-icon-credit-card-fill> Duplicatas</span
        >
        <div class="ContentTableBill">
          <div class="noContentTable" v-if="this.detailsSales.bills == ''">
            Não há duplicatas pagas registradas!
          </div>
          <table style="border-spacing: 1px 0; width: 100%" v-else>
            <thead
              style="
                color: whitesmoke;
                background: #3a4750;
                padding: 10px;
                height: 35px;
                text-align: center;
                border-spacing: 0;
              "
            >
              <tr>
                <th style="width: 10%">Data</th>
                <th style="width: 10%">Data Pagamento</th>
                <th style="width: 10%">Conta</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Forma de Pagamento</th>
                <th style="width: 10%">Vl Total</th>
                <th style="width: 10%">Vl Pago</th>
                <th style="width: 6%">Excluir</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="dataBill in this.detailsSales.bills"
                :key="dataBill.id"
                style="
                  text-align: center;
                  height: 60px;
                  border-bottom: 1px solid rgb(218, 218, 218);
                "
              >
                <td>
                  {{
                    dataBill.data.split(" ")[0].split("-").reverse().join("/")
                  }}
                </td>
                <td v-if="dataBill.dataPagamento">
                  {{
                    dataBill.dataPagamento
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </td>
                <td v-else>--</td>
                <td>{{ dataBill.nomeConta }}</td>
                <td>{{ dataBill.tipo }}</td>
                <td class="contentStatus" v-if="!dataBill.dataPagamento">
                  <b-icon-x-circle-fill
                    class="statusPaymentOpen"
                  ></b-icon-x-circle-fill>
                  <span style="width: 50%">Em aberto</span>
                </td>
                <td class="contentStatus" v-else>
                  <b-icon-check-circle-fill
                    class="statusPayment"
                  ></b-icon-check-circle-fill>
                  <span style="width: 50%">Pago</span>
                </td>
                <td v-if="dataBill.dataPagamento">
                  {{ dataBill.tipoFormaPagamento }}
                </td>
                <td v-else>--</td>
                <td>
                  {{
                    dataBill.valorTotal.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </td>
                <td>
                  {{
                    dataBill.valorPago.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </td>
                <td>
                  <b-icon-x-circle
                    scale="1.5"
                    class="delBill"
                    @click="deleteBill(dataBill.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal> -->
    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalSales" @click="modalHeight"> X </b-button>
        <Prescription
          v-if="this.typeDocument.venda"
          :typeComponent="outsideTypeSale"
        />
      </div>
    </div>

    <ModalConfirm
      modalName="drop-sale"
      title="Deseja realmente excluir ?"
      subtitle="Atenção! Esta ação não poderá ser desfeita. Ao confirmar, o registro e todas as parcelas financeiras associadas serão excluídos permanentemente."
      rightButtonText="Sim"
      leftButtonText="Não excluir"
      typeModal="danger"
      headerIcon="b-icon-exclamation-triangle-fill"
      :rightButtonClick="deleteSale"
    />

    <ModalDetailsSales
      modalName="modalDetailsSimpleSale"
      headerIcon="b-icon-exclamation-triangle-fill"
      :sale="detailsSales"
    />

    <Loading v-if="spinLoading" :text="textToModalLoading" />
  </div>
</template>
<script>
import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";

import Prescription from "../Prescription/Prescription.vue";
import Loading from "../Loading/Loading.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import ModalDetailsSales from "./ModalDetailsSales.vue";

import ServiceSale from "../../services/serviceSale";
import ServiceBill from "../../services/serviceBill";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";
import ServiceSettings from "../../services/serviceSettings";

import { TypeSale } from "../../utils/enums/SalesType";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { TypesOfSales } from "../../utils/enums/TypesOfSales";
import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import printReport from "../../reports/sale";
import { formatValuesFromSales } from "../../helpers/generalSales";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";
import { hasDigitalSignaturePermission } from "../../utils/digitalSignaturePermission";
import { hasSummaryValuesPermission } from "../../utils/summaryValuesPermission";

export default {
  props: {
    initialMonth: {
      type: Date,
      default: () => new Date(),
    },
    outsideTypeSale: {
      type: String,
      default: "Pedido",
    },
  },
  components: {
    Prescription,
    Loading,
    ModalConfirm,
    DropdownFilters,
    ModalDetailsSales,
  },
  data() {
    return {
      selectTextDate: "Este mês",
      year: DateTime.local().year,
      month: DateTime.local(),
      typeSale: TypeSale,
      spinLoading: false,
      spinGeneral: false,
      textPesquisa: "",
      type: "",
      typeOfSales: TypesOfSales.normal,
      typeSituation: "",
      status: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      modalContainer: "contentModalDisable",
      dataSale: [],
      totalMonth: 0,
      totalMonthSale: 0,
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      dataBills: "",
      page: 1,
      dataLength: 0,
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "numero", text: "Nº Operação" },
        { value: "", text: "Selecione..." },
      ],
      filterSalePerType: [
        { value: "Frente De Caixa", text: "Frente De Caixa" },
        { value: "Venda", text: "Venda" },
        { value: "Orçamento", text: "Orçamento" },
        { value: "", text: " Clique para selecionar o Status " },
      ],
      saleId: "",
      detailsSales: "",
      returnDataNote: null,
      motivo: "",
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      itemSelectedInTableSearch: null,
      textToModalLoading: "",
      showSubmenu: false,
      showSubmenuPrescription: false,
      showSubmenuGeneralSale: false,
    };
  },
  methods: {
    canUseDigitalSignature(saleType) {
      const permissionTypes = {
        Receita: "novaReceita",
        "Receita Pedido": "novoPedidoCompleto",
      };
      const permissionType = permissionTypes[saleType];
      return !!permissionType && hasDigitalSignaturePermission(permissionType);
    },

    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "ALTER_TYPE_DOCUMENT",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_DATA_NFE",
      "SET_ID_TRANSFORM_COMPLETED_SALE",
    ]),
    getIdSale(idSale) {
      this.saleId = idSale;

      this.findBill();
    },

    async getIdSaleDetails(idSale) {
      this.detailsSales = await this.findCompletedSale(idSale);
      this.saleId = idSale;

      const dataSalesFormated = this.detailsSales.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      this.detailsSales.data = dataSalesFormated;
    },

    async findBill() {
      this.detailsSales.bills = await ServiceBill.getAllBillsByParamsId(
        this.saleId,
        BillColumnsToSearchById.idVenda
      );
    },

    async findBillReportTicket(idSale) {
      const token = localStorage.getItem("token");
      const result = await ServiceSettings.findSettingsAtm();
      if (result.juros) {
        this.saleId = idSale;
        window.open(
          `${process.env.VUE_APP_URL_BACKEND}/bills/print/report/ticket/all/bills/and/format/carne/completed/with/pix/one/${this.saleId}?auth=${token}`
        );
      }
    },

    async deleteBill(id) {
      await ServiceBill.deleteAllRelationshipsFromDuplicate(id);

      this.findBill();
    },

    async deleteSale() {
      try {
        this.spinGeneral = true;
        await ServiceSale.deleteAll(this.saleId);

        await this.filterSale(1);
        this.$bvModal.hide("modal-center3");
        return this.$toast.open({
          message: "Venda removida com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterSale(page, byStatus) {
      if (this.selectTextDate === "Personalizado") {
        if (this.startDate && this.endDate) {
          const start = DateTime.fromISO(this.startDate);
          const end = DateTime.fromISO(this.endDate);
          const diffInMonths = end.diff(start, "months").months;

          if (diffInMonths > 6) {
            this.$toast.open({
              message:
                "Atenção! Período superior a 6 meses.Para esse intervalo, utilize o módulo Relatórios.",
              type: "info",
            });
            return;
          }

          if (end < start) {
            this.$toast.open({
              message: "A data final não pode ser anterior à data inicial",
              type: "warning",
            });
            return;
          }
        }
      }

      try {
        this.spinGeneral = true;

        if (!byStatus) this.status = "";

        const { data } = await api.get(
          `/sales?q=${this.textPesquisa}&type=${this.type}&status=${this.status}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=${this.outsideTypeSale}`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data.map((sale) => {
          if (sale.bills.length) {
            const totalPago = sale.bills?.reduce(
              (sum, bill) => sum + bill.valorPago,
              0
            );
            return { ...sale, totalPago };
          }

          return sale;
        });
        if (data.totals && Object.keys(data.totals).length) {
          this.countCancelado = data.totals.countCancelado;
          this.countFinalizado = data.totals.countFinalizado;
          this.countRascunho = data.totals.countRascunho;
          this.countFaturado = data.totals.countFaturado;

          this.totalcancelado = data.totals.cancelado;
          this.totalfinalizado = data.totals.finalizado;
          this.totalrascunho = data.totals.rascunho;
          this.totalFaturado = data.totals.faturado;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }

      await this.filterSale(1);
    },
    handleTypeSale(name) {
      this.status = name;

      this.filterSale(1, true);
    },

    nextPage() {
      this.filterSale((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1));
      }
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
        this.SET_DATA_SEARCH_FROM_SALE({});
      }
      this.filterSale(1);
    },

    async editSales(sale) {
      const data = await this.searchTableDataForSale(sale.id);

      if (data && Object.keys(data).length) {
        this.handleEditSale(data);
      }
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    async findCompletedSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/details/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_DOCUMENT(name);

      this.modalHeight();
    },

    handleEditSale(data) {
      if (this.outsideTypeSale !== "Pedido") data.tipo = "Receita Pedido";

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      this.page = 1;
    },

    async transformToNfe(idSale) {
      try {
        this.spinLoading = true;
        this.textToModalLoading =
          "Aguarde! A Sua nota fiscal está sendo emitida !";

        const dataNFe = await ServiceSale.transformInNotaToSend(idSale);

        this.SET_DATA_NFE(dataNFe);

        this.$toast.open({
          message: "Nota Fiscal Emitida!",
          type: "success",
        });

        this.$router.push({
          path: "/fiscal",
        });
      } catch (error) {
        if (
          error?.response?.data?.message &&
          error?.response?.data?.message?.includes("Validation failed")
        ) {
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        }

        return toastAlertErros.validateMessage(error, this.$toast);
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
      }
    },

    async handleDuplicateSale(dataSearchSale) {
      const data = await this.formatValuesToDuplicate(dataSearchSale.id);

      if (Object.keys(data).length) {
        data.numero = "";

        this.handleEditSale(dataSearchSale.tipo, data);
      }

      return;
    },

    async formatValuesToDuplicate(idSale) {
      const data = await this.searchTableDataForSale(idSale);

      const newProductsSale = data.products.map((prod) => {
        prod.id = "";
        prod.idVenda = "";

        return prod;
      });

      data.id = "";
      data.products = newProductsSale;
      data.bills = [];

      return data;
    },

    async sendCoupon(idSale) {
      try {
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! O Seu cupom está sendo emitido !";

        const data = await ServiceNotaFiscal.sendCoupon(idSale);
        this.responseNfeWebMania.danfe = await data.dataWebMania.danfe;
        this.visualizarNfe(this.responseNfeWebMania.danfe);

        await this.filterSale(1);
        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
      }
    },

    openModalDropSale(saleId) {
      this.saleId = saleId;
      this.$bvModal.show("drop-sale");
    },

    printReportReceipt(idSale) {
      printReport("receiptStandard", idSale);
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    async findNotaById(idNota) {
      this.returnDataNote = await ServiceNotaFiscal.findNotaById(idNota);
    },

    async findAndViewNote(idNota) {
      const notaReturn = await ServiceNotaFiscal.findNotaById(idNota);
      if (notaReturn.status === "Não Enviada") {
        this.$toast.open({
          message:
            "Houve um erro! Verifique se o documento foi emitido e tente novamente",
          type: "info",
        });
      } else {
        notaReturn.modelo == 1
          ? await this.printNf(notaReturn.id)
          : await this.printNfce(notaReturn.id);
      }
    },

    async printNf(id) {
      try {
        const pdfUrl = await ServiceNotaFiscal.printNf(id);

        window.open(pdfUrl, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async printNfce(id) {
      try {
        const danfe = await ServiceNotaFiscal.printNfce(id);

        const win = window.open(
          danfe,
          "_blank",
          "width=700, height=800, top=500, left=500"
        );

        win.document.write(danfe);

        win.document.close();
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async cancelNota() {
      try {
        const dataCancelamento = {
          uuid: this.returnDataNote.response.uuid,
          motivo: this.motivo,
        };
        this.spinLoading = true;
        this.textToModalLoading =
          "Aguarde! O Seu documento fiscal está sendo cancelado !";

        await ServiceNotaFiscal.cancelNota(
          dataCancelamento,
          this.returnDataNote.id
        );

        this.$toast.open({
          message: `${this.nameFiscalDocument} cancelada!`,
          type: "success",
        });

        await this.filterSale(1);
      } catch (error) {
        this.$toast.open({
          message: "Houve um erro! Verifique e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
        this.motivo = "";
      }
    },

    printCouponOrA4(type, idSale) {
      if (type === this.typeSale.frenteDeCaixa) {
        this.printReportCoupon(idSale);
      } else {
        this.printReportVendaOrcamento(idSale);
      }
    },

    printReportCoupon(idSale) {
      printReport("reportCoupon", idSale);
    },

    printReportVendaOrcamento(idSale) {
      printReport("reportVendaOrcamento", idSale);
    },

    async handleOpenModalAndFindFiscalDocument(nameModal, dataSearchSale) {
      this.itemSelectedInTableSearch = dataSearchSale;
      this.findNotaById(dataSearchSale.idNota);
      this.openModal(nameModal);
    },

    openModal(nameModal) {
      this.$bvModal.show(nameModal);
    },

    openModalVenda() {
      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    delayToOpen() {
      setTimeout(() => {
        this.openModalVenda();
      }, 500);
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      typeDocument: (state) => state.typeDocument,
      idTransformCompletedSale: (state) => state.idTransformCompletedSale,
    }),
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    canViewSummaryValues() {
      return hasSummaryValuesPermission("novoPedidoSimples");
    },
    nameFiscalDocument() {
      return String(
        this.itemSelectedInTableSearch?.modelosNota ||
          this.returnDataNote?.modelo
      ) === "2"
        ? "NFC-e"
        : "NF-e";
    },
    textTimeToCancel() {
      return this.nameFiscalDocument === "NFC-e" ? "30 MINUTOS" : "24 HORAS";
    },
  },
  async created() {
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    this.filterSale(1);
    this.ALTER_SIZE_MODAL("disable");

    if (this.idTransformCompletedSale) {
      const data = await this.searchTableDataForSale(
        this.idTransformCompletedSale
      );

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.delayToOpen();
      this.SET_ID_TRANSFORM_COMPLETED_SALE(null);
    }
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
  },
};
</script>
<style scoped>
.GeneralSales {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}
.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 65px;
  background: white;
  border-radius: 5px;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:focus {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:hover {
  background: #e3ebe2;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.Summary {
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 10px;
  justify-content: flex-start;
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}
.ContainerBtnSales {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  margin-top: 70px;
  width: 100%;
  gap: 1rem;
}

.BtnSales {
  width: 30%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.lineSearch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
  display: flex;
  align-items: center;
}
.searchByMonth {
  width: 30%;
  display: flex;
  align-items: center;
  margin: 20px 0px 0px 0px;
  border-radius: 5px;
  font-size: 11px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.searchFilter {
  width: 120px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  font-family: Poppins-Regular, sans-serif !important;
}
.inputSearch {
  width: 200px;
}
.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.disableInput {
  display: none;
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  font-weight: 600;
}

.custom-select2 {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  background: none;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  padding: 0 10px;
  border: 1px solid #e3e0e0;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  display: flex;
  justify-content: center;
}

.searchInputDate {
  width: 30%;
  display: flex;
}

.searchInputAll {
  width: 30%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.searchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 10px;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.form-control {
  display: block;
  width: 230px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  height: 30px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.Arrows {
  border-radius: 5px;
  width: 15px;
  height: 15px;
}

.Arrows:hover {
  background: whitesmoke;
}

.SummarySales {
  display: flex;
  width: 100%;
  padding: 15px 0;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.ballStatus {
  width: 10px;
  height: 10px;
  font-weight: bold;
  border-radius: 50%;
  font-size: 13px;
}
.generalContainer {
  display: flex;
  flex-direction: column;
  padding: 5px;
  width: 100%;
  max-width: 100%;
  background: white;
  border-radius: 5px;
}

.rowProvisionService {
  height: 100%;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 8%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}

.btnActions {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #cecece;
  border-radius: 5px;
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: white;
}
.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}

.ContentTableBill {
  display: flex;
  flex-direction: column;
  overflow: auto;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  padding: 0 0 10px 0;
  background: #fbfbfb;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
}

.noContentTable {
  background: #edebeb;
  padding: 10px;
  height: 100%;
  text-align: center;
  letter-spacing: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentStatus {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.contentStatus span {
  cursor: context-menu;
}

.statusPayment {
  background: #eff0f0;
  color: green;
}

.statusPaymentOpen {
  background: #eff0f0;
  color: rgb(132, 132, 132);
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.titleModalBill {
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #e6e7e8;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.closeModalBill {
  cursor: pointer;
}

.closeModalBill:hover {
  color: red;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnModalCancel {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contentBtns {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.contentMotivo {
  font-size: 13px;
  margin-bottom: 20px;
  padding: 10px;
}

.contentMotivo label {
  position: relative;
  top: 10px;
}

.contentMotivo textarea:focus {
  box-shadow: none;
  border: 1px solid rgb(97, 95, 95);
}

.contentMotivo span {
  position: relative;
  top: 10px;
  color: red;
  cursor: context-menu;
}

.contentMotivo ::placeholder {
  font-size: 12px;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.input-group-supplier {
  width: 45%;
  position: relative;
}

.user-label {
  position: absolute;
  left: 15px;
  font-size: 11px;
  z-index: 30;
  bottom: 21px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.closeModalDetails {
  width: 22px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -2px;
  top: -1px;
  color: red;
  border-radius: 2px;
  cursor: pointer;
  transition: ease-in all 0.2s;
  font-size: 18px;
}

.alertCancel {
  font-size: 10px;
  color: rgb(121, 3, 3);
  text-align: center;
  display: flex;
  margin-bottom: -10px;
  cursor: context-menu;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  border: none;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  top: 50%;
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loader {
  position: relative;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 30%,
      15% 54%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 69%,
      100% 32%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalSales {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalSales:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnActions1:hover {
  background: rgb(215, 213, 213);
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: rgb(82, 78, 78);
}

.dropdown-submenu {
  position: relative;
}

.submenu {
  position: absolute;
  top: 0;
  right: 100%;
  background: white;
  border: 1px solid #ddd;
  min-width: 160px;
  z-index: 1000;
  border-radius: 0.25rem;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.1);
}

.submenu .dropdown-item {
  white-space: nowrap;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none !important;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

.typeSale2 {
  color: #48b865;
  font-weight: bold;
}

.typeSale3 {
  color: #006256;
  font-weight: bold;
}

.typeSale4 {
  color: rgb(34, 33, 36);
  font-weight: bold;
}

.typeSale5 {
  color: #f2a83e;
  font-weight: bold;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.situationContent {
  display: flex;
  align-items: center;
  width: 90px;
  justify-content: flex-start;
  font-weight: bold;
}

.situationContent span {
  margin: 0 0 0 10px;

  font-weight: 600;
}

.situationContainer {
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.summaryMonthText {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.month {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 758px) and (max-width: 1200px) {
  .GeneralSales {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }

  .searchByMonth {
    width: 40%;
    margin: 10px 0px 0px 10px;
  }

  .form-control {
    width: 140px;
  }

  .ItemSummarySales {
    height: 60px;
    font-size: 11px;
  }

  .SummarySales {
    height: 100px;
    padding-bottom: 10px;
  }

  .BtnSales {
    height: 30px;
    font-size: 11px;
  }

  .searchAll {
    font-size: 11px;
    padding: 5px 9px;
  }

  .searchInputAll {
    width: 18%;
  }

  .searchInputDate {
    width: 45%;
  }

  .btnPeriod {
    width: 60px;
    font-size: 10px;
  }

  .searchFilter {
    width: 110px;
    font-size: 10px;
  }

  .searchContainer {
    height: 70px;
  }

  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }

  .headTable {
    height: 25px;
  }

  .ContentTable {
    padding: 0px 20px 0 20px;
  }
}

@media screen and (max-width: 700px) {
  .GeneralSales {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 100%;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtnSales {
    margin-top: 55px;
    flex-wrap: wrap;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    margin-left: 0px;
    justify-content: center;
  }

  .searchContainer {
    display: none;
  }

  .BtnSales {
    height: 70px;
  }

  .searchByMonth {
    width: 80%;
    margin: 20px 0px 0px 0px;
  }

  .ItemSummarySales {
    height: 100px;
  }

  .ContentTable {
    height: auto;
    padding: 10px 10px 0 10px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>
